var $07ce387156cf9cb1$exports = {};
$07ce387156cf9cb1$exports = {
    "backButton": (args)=>`Retornar a ${args.prevMenuButton}`,
    "moreActions": `Mais a\xe7\xf5es`,
    "unavailable": `Indispon\xedvel. Expanda para ver os detalhes`
};


export {$07ce387156cf9cb1$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
